<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="inviteComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="inviteComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header h5 bg-transparent border-0">Invitation List</div>
          <div class="card-body">
              <v-client-table :data="data" :columns="tableColumns" :options="tableOptions">
                <div slot="inviteSelect" slot-scope="props">
                  <a href="#" class="" @click="changeRightView('invite-single', props.row.id, '')"><i class="fa fa-envelope-o" aria-hidden="true"></i></a>
                </div>
              </v-client-table>
          </div>
        </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {

  data: function () {
    return { 

      tableColumns: ['email', 'role', 'diff', 'created_at', 'inviteSelect'],
      tableOptions: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: true,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 15,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: { }, 
        headings: { 

          email: 'Email',
          role: 'Role',
          diff: 'Time',
          inviteSelect: '',
        },

      }
    }
  },
  computed: {
    data () { return this.$store.state.inviteArray },
    inviteComp () { return this.$store.state.inviteComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },

  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
